import { countries } from 'constants/countries';
var iso2IndexedByDialCode = countries.reduce(function (out, country) {
    out[country.dialCode] = country.iso2;
    return out;
}, {});
/**
 * Convert a string to camel case
 *
 * @param {string} str - The string to be formatted
 * @returns {string} - The formatted string to camelCase
 */
export var camelCase = function (str) {
    str = str.toLowerCase().trim();
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (ltr, idx) {
        return idx === 0 ? ltr.toLowerCase() : ltr.toUpperCase();
    })
        .replace(/\s+/g, '');
};
/**
 * A naive output format for north american phone numbers.
 *
 * @param {string} phoneNumberString - number to format
 * @returns {string} - Something more like (555) 555-5555 or on failure, the original string.
 */
export var formatPhoneNumber = function (phoneNumberString) {
    if (!phoneNumberString)
        return { fullNumber: '', number: '' };
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(.*)(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        if (match[1]) {
            var maybeCode = match[1];
            var maybeIso2 = iso2IndexedByDialCode[maybeCode];
            if (maybeIso2) {
                return {
                    dialCode: maybeCode,
                    countryCode: maybeIso2,
                    number: "(".concat(match[2], ") ").concat(match[3], "-").concat(match[4]),
                    fullNumber: "+".concat(maybeCode, " (").concat(match[2], ") ").concat(match[3], "-").concat(match[4]),
                };
            }
        }
        return {
            fullNumber: "(".concat(match[2], ") ").concat(match[3], "-").concat(match[4]),
            number: "(".concat(match[2], ") ").concat(match[3], "-").concat(match[4]),
        };
    }
    return { number: phoneNumberString, fullNumber: phoneNumberString };
};
/**
 * A lil doohickey tool to grab initials from a member's name
 *
 * @param {string} memberName - name to get initials from
 * @returns {string} - returns something like 'J.L.' for John Lidstone or 'A.P.' for Aaron Propst
 */
export var getInitials = function (memberName) {
    if (!memberName)
        return '';
    var splitString = memberName === null || memberName === void 0 ? void 0 : memberName.split(' ');
    return "".concat(splitString[0].substring(0, 1), ".").concat(splitString[1].substring(0, 1), ".");
};
export var formatPostalAddress = function (postalAddress) {
    var addressArray = [
        postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.street_address_1,
        postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.street_address_2,
        postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.city,
        postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.state,
        postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.zip_code,
        postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.country,
    ];
    return addressArray
        .filter(function (element) {
        return element !== null && element !== undefined && element != '';
    })
        .join(', ');
};
/**
 * Auto-capitalize each word of a tricky string
 *
 * @param {string} text - whatever text you want to modify
 * @returns {string} - returns something like 'Suicide Risk' or 'Depression Symptoms' for 'Suicide risk' or 'Depression symptoms'
 */
export var capitalizeEachFirstChar = function (text) {
    text = text
        .split(' ')
        .map(function (s) { return s.charAt(0).toUpperCase() + s.substring(1); })
        .join(' ')
        .split('-')
        .map(function (s) { return s.charAt(0).toUpperCase() + s.substring(1); })
        .join('-');
    return text;
};
export var parseJwt = function (token) {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    }
    catch (e) {
        return null;
    }
};
